/* eslint-disable react/no-array-index-key */
import React, { FC, useEffect, useState } from 'react';

import AuthThankYou from '../../components/Auth/AuthThankYou';
import SectionWrapper from '../../components/SectionWrapper';
import { TMessagingBlade } from '../../models/Message/@types';
import { getMessageData } from '../../models/Message/api';
import styles from './pageNotFound.module.sass';

const PageNotFoundScreen: FC = () => {
  useEffect(() => {
    const fetchData = async () => {
      const pageNotFound = await getMessageData(['page-not-found']);
      setmodalData(pageNotFound['page-not-found']);
    };
    fetchData();
  }, []);

  const [modalData, setmodalData] = useState<TMessagingBlade>();

  return (
    <SectionWrapper classes={`${styles.root}`}>
      <AuthThankYou {...modalData} />
    </SectionWrapper>
  );
};

export default PageNotFoundScreen;
